import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getMetaDetailList = createAsyncThunk(
  "metaDetailList/getMetaDetailList",
  async (data, { rejectWithValue }) => {
    const apiUrl = process.env.REACT_APP_API_URL;

    // Ensure it only runs for local and live environments
    if (apiUrl === "https://api-mopforce.demo-available.com") {
      return rejectWithValue("Demo environment is not allowed");
    }
    try {
      const response = await axios.post(`${apiUrl}/api/meta/get_by_id`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const metaDetailsSlice = createSlice({
  name: "metaDetailList",
  initialState: {
    loading: false,
    metaDetailData: null,
    error: null,
  },
  reducers: {
    clearMetaDetailData: (state) => {
      state.metaDetailData = null; // Clear old data
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMetaDetailList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMetaDetailList.fulfilled, (state, action) => {
        state.loading = false;
        state.metaDetailData = action.payload;
      })
      .addCase(getMetaDetailList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const { clearMetaDetailData } = metaDetailsSlice.actions;
export default metaDetailsSlice.reducer;
